// Copyright (c) 2017 Deere & Company

import busyCounter from '../../../shared/reducers/busy-counter';
import {combineReducers} from 'redux';
import dealerInvoices from './dealer-invoices';
import facets from './facets';
import hasSearchResults from '../../shared/reducers/has-search-results';
import invoiceToComplete from './invoice-to-complete';
import searchByDropDown from '../../shared/reducers/search-by-dropdown';
import searchFilters from './search-filters';
import searchQueryString from '../../shared/reducers/search-query-string';

export const getCombinedReducers = () => combineReducers({
    busyCounter,
    dealerInvoices,
    facets,
    hasSearchResults,
    invoiceToComplete,
    searchByDropDown,
    searchFilters,
    searchQueryString
});



// WEBPACK FOOTER //
// ./src/claim/dealer-invoices/reducers/index.js